import { TFunction } from 'i18next';
import { GetLabelFn } from 'types/general';

export type { GetLabelFn };

export function buildLabelGetter(key: string): GetLabelFn {
  return (t: TFunction) => t(key);
}
